export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10547.6eb8d895.jpg";